var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// components/ge-input.ts
import "@adornis/chemistry/chemistry-lit-element";
import { css } from "@adornis/chemistry/directives/css";
import "@adornis/chemistry/elements/components/x-flex";
import "@adornis/chemistry/elements/components/x-icon";
import { inputToken } from "@adornis/chemistry/elements/theming/input-token";
import { ElementsInput } from "@adornis/forms/x-input";
import merge from "deepmerge";
import { html } from "lit";
import { customElement } from "lit/decorators.js";
import { baseFontSize } from "../constants";
import "./../fonts";
var germaniumInputToken = (host) => merge(inputToken(host), {
  borderRadius: "4px",
  border: `1px solid ${host.colors.secondary}`,
  background: "transparent"
});
var GermaniumInput = class extends ElementsInput {
  constructor() {
    super(...arguments);
    this["placeholder-mode"] = "hide";
    this.styles = () => {
      return [
        ...super.styles(),
        {
          ":host": {
            height: "unset",
            fontSize: baseFontSize,
            "--placeholder-color": "rgba(160, 171, 180, 0.75)"
          },
          ":host([error]) x-flex > x-flex": { borderColor: this.colors.tone.error },
          ":host([on-dark])": {
            background: "white",
            borderRadius: "4px",
            color: this.colors.on.neutral_100
          },
          "x-flex > x-flex": {
            border: `1px solid ${this.colors.secondary}`,
            background: "transparent",
            borderRadius: "4px"
          }
        }
      ];
    };
  }
  get inputToken() {
    return germaniumInputToken(this);
  }
  iconDisplay() {
    return this.icon || (this.type === "password" || this.isPasswordInput) && !this["no-password-toggle"] ? html`
          <x-icon
            type="material-outlined"
            ${css({ marginRight: this.spacing?.sm, cursor: "pointer", fontFamily: "Material Icons Outlined" })}
            @click="${() => {
      if (!this.icon && (this.type === "password" || this.isPasswordInput)) {
        if (this.type === "text" && this.isPasswordInput)
          this.type = "password";
        else if (this.type === "password") {
          this.isPasswordInput = true;
          this.type = "text";
        }
      }
      this.dispatchEvent(new CustomEvent("icon-click"));
    }}"
          >
            ${this.icon || (this.type === "password" ? "visibility_off" : this.isPasswordInput ? "visibility_on" : "")}
          </x-icon>
        ` : "";
  }
};
GermaniumInput = __decorateClass([
  customElement("ge-input")
], GermaniumInput);
export {
  GermaniumInput,
  germaniumInputToken
};
